import React from "react";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";
import { telemetry } from "@/utilities/telemetry";

const FooterContent = ({ className }: { className?: string }) => (
  <p className={className}>
    Your data isn't in a pickle — it's protected with industry-leading
    encryption.{" "}
    <SupportLink
      options={{ labels: ["weblink-why-we-collect-info"] }}
      hideChevron
      onClick={() => telemetry.learnMoreClickedInSignUp()}
    >
      Learn more about why it's important to us!
    </SupportLink>
  </p>
);

export { FooterContent };
